module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }